/* Countries.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._18u0idpf{margin-left:0}";
const _10 = "._otyridpf{margin-bottom:0}";
const _9 = "._2hwxidpf{margin-right:0}";
const _8 = "._19pkidpf{margin-top:0}";
const _7 = "._1bsb1k8s{width:1.5rem}";
const _6 = "._4t3i1k8s{height:1.5rem}";
const _5 = "._4cvr1h6o{align-items:center}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal } from '@atlassian/mpac-primitives';
import { getCountryByIsoCode } from '@atlassian/mpac-utils';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._19pkx0bf{margin-top:var(--ds-space-negative-100,-8px)}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const Wrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4 _19pkx0bf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Wrapper.displayName = 'Wrapper';
}
const CountryWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _4t3i1k8s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CountryWrapper.displayName = 'CountryWrapper';
}
const Flag = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1k8s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Flag.displayName = 'Flag';
}
const CountryName = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CountryName.displayName = 'CountryName';
}
export const Countries = _ref5 => {
  let {
    isoCodes
  } = _ref5;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: isoCodes.map(getCountryByIsoCode).filter(Boolean).map((country, index) => {
      const {
        name,
        icon
      } = country;
      return /*#__PURE__*/_jsxs(CountryWrapper, {
        children: [/*#__PURE__*/_jsx(Flag, {
          "data-testid": "flag-".concat(index),
          children: icon
        }), /*#__PURE__*/_jsx(CountryName, {
          children: name
        })]
      }, name);
    })
  });
};